import React from 'react';
import ReportingContainer from '../../component/Reporting/ReportingContainer';

const render = () => <ReportingContainer />;

export default render;
